import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {LotteryPage} from "../../pages/lottery/lottery";
import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'select-mark-num',
    templateUrl: 'selectMarkNum.html'
})
export class SelectMarkNum implements OnInit {

    @Input() selectOption: any;
    @Input() noBigIndex: number;

    @Output() onSelectedNum: EventEmitter<any> = new EventEmitter();
    //球的配置参数
    selectArray = [];
    //选球的号码
    selectNo = [];
    isSingle: boolean = false;
    noButton: boolean = false;

    private btnsOption = [];
    private selectBtnOptionIndex = 0;

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
        this.initView();
    }

    initView() {
        this.selectNo = [];
        this.selectArray = [];
        this.noButton = !(this.selectOption.isButton == false);
        this.isSingle = (this.selectOption.single == true);
        if (this.selectOption.onlyClear == true) {
            this.btnsOption = [
                {
                    text: this.translate.instant('OPTIONS.ALL'),
                    type: "all",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.CLEAR'),
                    type: "clear",
                    isSelect: false
                }
            ];
        } else {
            this.btnsOption = [
                {
                    text: this.translate.instant('OPTIONS.ALL'),
                    type: "all",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.BIG'),
                    type: "big",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.SMALL'),
                    type: "small",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.ODD'),
                    type: "odd",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.EVEN'),
                    type: "even",
                    isSelect: false
                },
                {
                    text: this.translate.instant('OPTIONS.CLEAR'),
                    type: "clear",
                    isSelect: false
                }
            ];
        }
        this.selectOption.no.split('|').forEach((value) => {
            this.selectArray.push({
                text: value,
                num: Number(value),
                isSelect: false
            });
        });
    }

    selectNum(index) {
        this.setSelectNo(index);
        this.onSelectedNum.emit({
            selectOption: this.selectOption,
            selectNo: this.selectNo
        });
        LotteryPage.clickPlay();
    }

    getSelectOption() {
        return this.selectOption;
    }

    selectBtnOption(selectType: string, index) {
        this.btnsOption[this.selectBtnOptionIndex].isSelect = false;
        this.selectBtnOptionIndex = index;
        if (index !== 5) {
            this.btnsOption[index].isSelect = true;
        }
        let optionFns = {
            'all': this.allOption,
            'big': this.bigOption,
            'small': this.smallOption,
            'odd': this.oddOption,
            'even': this.evenOption,
            'clear': this.clearOption
        };
        let me = this;
        optionFns[selectType](me);
        this.setSelectNo1();
        this.onSelectedNum.emit({
            selectOption: this.selectOption,
            selectNo: this.selectNo
        });
    }

    allOption(me) {
        me.selectArray.map(item => {
            item.isSelect = true;
            return item;
        });
    }

    clearOption(me) {
        me.selectArray.map(item => {
            item.isSelect = false;
            return item;
        });
    }

    bigOption(me) {
        me.selectArray.map(item => {
            item.isSelect = item.num >= me.noBigIndex;
            return item;
        });
    }

    smallOption(me) {
        me.selectArray.map(item => {
            item.isSelect = item.num < me.noBigIndex;
            return item;
        });
    }

    oddOption(me) {
        me.selectArray.map(item => {
            item.isSelect = item.num % 2 == 1;
            return item;
        });
    }

    evenOption(me) {
        me.selectArray.map(item => {
            item.isSelect = item.num % 2 == 0;
            return item;
        });
    }

    setSelectNo1() {
        this.selectNo = [];
        this.selectArray.forEach(item => {
            if (item.isSelect) {
                this.selectNo.push(item.text);
            }
        });
    }

    setSelectNo(index: number) {
        this.selectArray[index].isSelect = !this.selectArray[index].isSelect;
        if (this.selectOption.hasOwnProperty("maxSelect") && this.selectArray[index].isSelect
            && this.selectOption["maxSelect"] == this.selectNo.length) {
            this.replaceNo(index);
        } else {
            this.addNo(index);
        }
    }

    /**
     * 替换号码
     * @param index
     */
    replaceNo(index: number) {
        let noText = this.selectNo.pop();
        this.selectArray.map(item => {
            if (item.text == noText) {
                item.isSelect = false;
            }
            return item;
        });
        this.selectNo.push(this.selectArray[index].text)
    }

    /**
     * 添加号码
     * @param index
     */
    addNo(index: number) {
        this.selectNo = [];
        this.selectArray.map((item, itemIndex) => {
            if (this.isSingle == true) {
                item.isSelect = index == itemIndex;
            }
            if (item.isSelect) {
                this.selectNo.push(item.text);
            }
            return item;
        });
    }

    /**
     * 删除号码信息
     * @param selectNo
     */
    deleteNo(deleteNo: any) {
        let selectNo1 = [];
        this.selectArray.map((item) => {
            if (this.selectNo.indexOf(item.text) > -1) {
                if (deleteNo.indexOf(item.text) > -1) {
                    item.isSelect = false;
                } else {
                    selectNo1.push(item.text)
                }
            }
            return item;
        });
        this.selectNo = selectNo1;
    }
}




// WEBPACK FOOTER //
// ./src/component/selectMarkNum/selectMarkNum.ts